import type { Tables } from '@/shared/types/tables';
import type { AuthUser } from './types';

/** Map a `profiles` row + auth email into the UI-facing `AuthUser`. */
export function mapProfileToUser(profile: Tables<'profiles'>, email: string): AuthUser {
  return {
    id: profile.id,
    email,
    name: profile.name,
    initials: profile.initials,
    avatarColor: profile.avatar_color,
    avatarUrl: profile.avatar_url,
    role: profile.role,
    bio: profile.bio,
  };
}
